import {BiGitRepoForked} from "react-icons/bi";
import {AiFillGithub, AiFillEye} from "react-icons/ai";

import maze from "../images/maze.png"
import vaccine from "../images/vaccine.png"
import netflix from "../images/netflix.webp"
import fake from "../images/fake.webp"
import cuda from "../images/cuda.jpg"

const projectConfig = [
    {
        id: "project-4",
        title: "Artificial Intelligence Berkley's CS188 Pacman solutions",
        links: [
            {
                name: "repo",
                url: "https://github.com/TollisK/AI-Berkley-CS188-Solutions",
                icon: <AiFillGithub/>,

            },
            {
                name: "fork",
                url: "https://github.com/TollisK/AI-Berkley-CS188-Solutions/fork",
                icon: <BiGitRepoForked/>,

            },
            {
                name: "subscription",
                url: "https://github.com/TollisK/AI-Berkley-CS188-Solutions/subscription",
                icon: <AiFillEye/>,

            }
        ],
        image: maze,
        description: "Solutions for Berkeley's CS188 Spring 2019 projects 0, 1, 2 and 3 using A.I. algorithms",
        target: "_blank"
    },
    {
        id: "project-3",
        title: "Vaccine Monitor App",
        links: [
            {
                name: "repo",
                url: "https://github.com/TollisK/System-Programming",
                icon: <AiFillGithub/>
            },
            {
                name: "fork",
                url: "https://github.com/TollisK/System-Programming/fork",
                icon: <BiGitRepoForked/>
            },
            {
                name: "subscription",
                url: "https://github.com/TollisK/System-Programming/subscription",
                icon: <AiFillEye/>
            }
        ],
        image: vaccine,
        description: "This project implements a real life vaccine monitor app simulator with one client and miltiple servers.",
        target: "_blank"
    },
    {
        id: "project-2",
        title: "Netflix Analysis and Recommendation System",
        links: [
            {
                name: "repo",
                url: "https://github.com/TollisK/Netflix-Data-Mining",
                icon: <AiFillGithub/>
            },
            {
                name: "fork",
                url: "https://github.com/TollisK/Netflix-Data-Mining/fork",
                icon: <BiGitRepoForked/>
            },
            {
                name: "subscription",
                url: "https://github.com/TollisK/Netflix-Data-Mining/subscription",
                icon: <AiFillEye/>
            }
        ],
        image: netflix,
        description: "A data analysis notebook along with a recommendation system with Netflix data for Data mining course at UoA.",
        target: "_blank"
    },
    {
        id: "project-1",
        title: "Fake news detection",
        links: [
            {
                name: "repo",
                url: "https://github.com/TollisK/Fake-news-detection-Data-Mining",
                icon: <AiFillGithub/>
            },
            {
                name: "fork",
                url: "https://github.com/TollisK/Fake-news-detection-Data-Mining/fork",
                icon: <BiGitRepoForked/>
            },
            {
                name: "subscription",
                url: "https://github.com/TollisK/Fake-news-detection-Data-Mining/subscription",
                icon: <AiFillEye/>
            }
        ],
        image: fake,
        description: "The project is the categorization of text data by news articles and specifically the detection of fake news. The data contains 2 files in csv format (Fake.csv, True.csv).",
        target: "_blank"
    },
    {
        id: "project-0",
        title: "Jacobi Method implementation using CUDA",
        links: [
            {
                name: "repo",
                url: "https://github.com/TollisK/CUDA-Jacobi-Method-Parallel-Programming",
                icon: <AiFillGithub/>
            },
            {
                name: "fork",
                url: "https://github.com/TollisK/CUDA-Jacobi-Method-Parallel-Programming/fork",
                icon: <BiGitRepoForked/>
            },
            {
                name: "subscription",
                url: "https://github.com/TollisK/CUDA-Jacobi-Method-Parallel-Programming/subscription",
                icon: <AiFillEye/>
            }
        ],
        image: cuda,
        description: "Calculate the Jacobi Method using CUDA for parallel programming course at UoA.",
        target: "_blank"
    },
    {
        id: "project-5",
        title: "Natural Language Processing",
        links: [
            {
                name: "repo",
                url: "https://github.com/TollisK/Natural-Language-Processing-AI-2",
                icon: <AiFillGithub/>
            },
            {
                name: "fork",
                url: "https://github.com/TollisK/Natural-Language-Processing-AI-2/fork",
                icon: <BiGitRepoForked/>
            },
            {
                name: "subscription",
                url: "https://github.com/TollisK/Natural-Language-Processing-AI-2/subscription",
                icon: <AiFillEye/>
            }
        ],
        image: "https://canopylab.com/wp-content/uploads/2019/11/shutterstock_1455391502-2.jpg",
        description: "Vaccine sentiment classifier that was trained and tested using Twitter data.  Modules: PyTorch, NumPy, Pandas, Matplotlib, scikit-learn, and nltk.",
        target: "_blank"
    }
]

export default projectConfig